import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_globalTranslations } from "@App/locales/de_DE-globalTranslations";

export const signaliduna = {
  ...de_DE_formal,
  ...{
    translation: {
      ...de_DE_globalTranslations.translation,
      hero: {
        title: "<strong>{{organization}}<br>Werkstatt-Buchung</strong>",
        subtitle: null,
      },
      welcomeModal: {
        title: "Sie verlassen nun die Seite von SIGNAL IDUNA",
        text: "Bitte beachten Sie, dass Sie sich auf einer Website befinden, für deren Inhalt SIGNAL IDUNA nicht verantwortlich ist und die Datenschutzbestimmungen von SIGNAL IDUNA keine Anwendung finden.",
      },
      layout: {
        backText: "Zurück zu signal-iduna.de",
        navbar: {
          partnerLogo: {
            alt: "SIGNAL IDUNA",
          },
        },
      },
      linkToHome: "https://werkstatt.repareo.de/partner/signal-iduna",
      contactForm: {
        ...de_DE_globalTranslations.translation.contactForm,
        "mileage-label": "Kilometerstand (ungefähr)",
      },
    },
  },
};
